
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

// Enhanced initialization to prevent FOUC and console warnings
const initializeApp = () => {
  const rootElement = document.getElementById("root");
  
  if (!rootElement) {
    console.error('Root element not found');
    return;
  }

  const root = createRoot(rootElement);

  // Ensure theme is applied before rendering to prevent FOUC
  const applyInitialTheme = () => {
    try {
      const savedTheme = localStorage.getItem('theme') || 'dark';
      document.documentElement.setAttribute('data-theme', savedTheme);
    } catch (error) {
      // Fallback to dark theme if localStorage is not available
      document.documentElement.setAttribute('data-theme', 'dark');
    }
  };

  // Apply theme immediately
  applyInitialTheme();

  root.render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
};

// Enhanced DOM ready detection with error handling
const handleDOMReady = () => {
  try {
    initializeApp();
  } catch (error) {
    console.error('Failed to initialize app:', error);
    // Still try to render a basic version
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = '<div>Application failed to load. Please refresh the page.</div>';
    }
  }
};

// Multiple fallbacks for DOM ready state
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', handleDOMReady, { once: true });
} else if (document.readyState === 'interactive' || document.readyState === 'complete') {
  // Use setTimeout to ensure all stylesheets are loaded
  setTimeout(handleDOMReady, 0);
} else {
  // Final fallback
  handleDOMReady();
}

// Additional safety net for stylesheet loading
if (document.readyState !== 'complete') {
  window.addEventListener('load', () => {
    // Ensure body is visible after all resources are loaded
    document.body.classList.add('theme-loaded');
  }, { once: true });
}
